export default __webpack_public_path__ + "locales/fi/JavascriptSdk.json?hash=bfebf1beca2e18601480131650210a3f";